import React from "react";
import PropTypes from "prop-types";
import objectAssign from "object-assign";
import { bindActionCreators } from "redux";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { CONFIGURATION } from "../../constants/config";
import * as buttonTypes from "../../constants/buttonTypes";

import * as courseUtilities from "../../utilities/courseUtilities";
import * as courseActions from "../../actions/courseActions";
import * as modalActions from "../../actions/modalActions";
import multiLocThumbnail from "../../assets/Multi-Loc-Card.png";

import SvgIcon from "../icon/SvgIcon";
import Button from "../inputs/Button";
import CourseOfferingCard from "./CourseOfferingCard";

class CourseOfferingGroupCard extends React.Component {
  constructor(props) {
    super(props);

    this.thumbnailRef = React.createRef();

    this.showCourseSelectionModal = this.showCourseSelectionModal.bind(this);
    this.getCourseSelectionList = this.getCourseSelectionList.bind(this);
  }

  showCourseSelectionModal() {
    this.props.actions.showDefaultModal(
      this.getCourseSelectionList(),
      "Pick Your Course Offering",
      true,
      true,
      "padded-stretch"
    );
  }

  getCourseSelectionList() {
    return (
      <div className="row">
        {this.props.courseOfferingGroup.courseOfferings.map(
          (courseOffering) => (
            <div key={courseOffering.uniqueId} className="col-12 col-sm-6">
              <CourseOfferingCard
                courseOffering={courseOffering}
                featured
              />
            </div>
          )
        )}
      </div>
    );
  }

  render() {
    let { courseOfferingGroup } = this.props;
    let formatsVary = courseUtilities.courseOfferingFormatsVary(
      courseOfferingGroup.courseOfferings
    );
    let courseGroupDate = courseUtilities.GetCourseGroupDate(
      courseOfferingGroup.courseOfferings
    );
    let iconColor = "white";
    return (
      <div className="course-card L">
        <div className="course-card-image-container">
        <div className="course-card-image">
        <img src={multiLocThumbnail} />
        </div>
        </div>
        <div className="course-card-details">
          <div className="course-text">
            <div className="course-status info">
              <span>
                <SvgIcon icon="cal" color="white" />
              </span>
              <span> Live Multi-Format </span>

              {/* Course status temporarily commented  */}
              {/* <span> {courseOfferingGroup.statusText} </span> */}
            </div>

            <div className="card-body">
              <h5 onClick={this.showCourseSelectionModal}>
                <b>
                  <MediaQuery maxWidth={CONFIGURATION.MAX_XS_WIDTH}>
                    {(matches) => {
                      //need to display shorter titles on mobile
                      if (matches)
                        return courseUtilities.truncateCourseName(
                          courseOfferingGroup.course.name,
                          40
                        );
                      else
                        return courseUtilities.truncateCourseName(
                          courseOfferingGroup.course.name,
                          70
                        );
                    }}
                  </MediaQuery>
                </b>
              </h5>

              <hr className="course-content-divider info" />

              <p className="block-with-text">
                {courseOfferingGroup.summaryDescription}
              </p>
            </div>
            <div className="course-subtext">
              <div className="course-subtext-container">
                <div className="bottom-left">
                  <p>
                    {formatsVary ? (
                      <React.Fragment>
                        <SvgIcon icon="pin-sm" color={iconColor} />
                        <SvgIcon icon="webinar-sm" color={iconColor} />
                        <span className="detail">Multiple Formats</span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <SvgIcon icon="pin-sm" color={iconColor} />
                        <span className="detail">Multiple Locations</span>
                      </React.Fragment>
                    )}
                  </p>
                  <p>
                    <SvgIcon icon="cal-sm" color={iconColor} />
                    {courseGroupDate ? (
                      <span className="detail">
                        {courseUtilities.formatOfferingDate(
                          null,
                          courseGroupDate
                        )}
                      </span>
                    ) : (
                      <span className="detail">Multiple Dates</span>
                    )}
                  </p>
                  <p>
                    <SvgIcon icon="credits-number-sm" />{" "}
                    {courseOfferingGroup.course.ceHours == 0 && (
                      <span className="detail">No Credit</span>
                    )}
                    {courseOfferingGroup.course.ceHours > 0 && (
                      <span className="detail">
                        {courseOfferingGroup.course.ceHours} Credits
                      </span>
                    )}
                  </p>
                  <p>
                    <SvgIcon icon="course-number-sm" color={iconColor} />
                    <span className="detail">
                      Course #{courseOfferingGroup.course.cdiCourseCode}
                    </span>
                  </p>
                </div>
                <div className="bottom-right">
                  <NavLink
                    className="clickable"
                    to=""
                    onClick={this.showCourseSelectionModal}
                  >
                    <SvgIcon icon="info" />
                    Details
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul className="course-card-primary-actions">
          <li className="actions-item">
            <Button
              onClick={this.showCourseSelectionModal}
              label="Register"
              svgIcon
              icon="add"
              iconColor="white"
              hoverIconColor={"green"}
              buttonType={buttonTypes.SUCCESS}
            />
          </li>
        </ul>
      </div>
    );
  }
}

CourseOfferingGroupCard.propTypes = {
  history: PropTypes.object.isRequired,
  courseOfferingGroup: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.auth.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  const combinedActions = objectAssign({}, courseActions, modalActions);

  return {
    actions: bindActionCreators(combinedActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CourseOfferingGroupCard)
);
